// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"10632bdd","455":"b103ca3d","977":"6bc48ff6"}[chunkId] + ".chunk.js";
};